import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerReportingLine: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ reportingLineSetupRequestHandler }, { ReportingLineSetupPresets, reportingLineSetupStore }] = await Promise.all([import("./mocks/reportingLineSetupRequestHandler.ts"), import("./mocks/store.ts")]);
        const requestedPreset = new URLSearchParams(window.location.search).get("mock-reporting-line");
        const preset = ReportingLineSetupPresets.find(name => name === requestedPreset);

        if (preset) {
            reportingLineSetupStore.applyPreset(preset);
        }

        runtime.registerRequestHandlers([reportingLineSetupRequestHandler]);
    }
};
